import { render, staticRenderFns } from "./AccountClaim.vue?vue&type=template&id=1b2227fd&scoped=true&"
import script from "./AccountClaim.vue?vue&type=script&lang=js&"
export * from "./AccountClaim.vue?vue&type=script&lang=js&"
import style0 from "./AccountClaim.vue?vue&type=style&index=0&id=1b2227fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2227fd",
  null
  
)

export default component.exports